export const qk = {
  counts: (cid: string | null) => ["counts", cid] as const,
  truckYardCounts: (cid: string | null) => ["truckYardCounts", cid] as const,

  statuses: () => ["statuses"] as const,
  icons: {
    list: () => ["icons", "list"] as const,
  },
  roles: () => ["roles"] as const,
  access: {
    me: (userId: string | null) => ["access", "me", userId] as const,
    role: (roleId: string | null) => ["access", "role", roleId] as const,
    company: (companyId: string | null) => ["access", "company", companyId] as const,
    profiles: () => ["access", "profiles"] as const,
    profileUsage: (profileId: string | null) =>
      ["access", "profile-usage", profileId] as const,
    user: (userId: string | null) => ["access", "user", userId] as const,
  },
  brands: () => ["brands"] as const,

  devices: {
    list: (cid: string | null, f: object) => ["devices", "list", cid, f] as const,
    all: (cid: string | null) => ["devices", "all", cid] as const,
    light: (cid: string | null, s: string) => ["devices", "light", cid, s] as const,
  },
  vehicles: {
    list: (cid: string | null, f: object) => ["vehicles", "list", cid, f] as const,
    all: (cid: string | null) => ["vehicles", "all", cid] as const,
    available: (cid: string | null, withDevices = false) =>
      ["vehicles", "available", cid, withDevices] as const,
  },
  users: {
    list: (cid: string | null, f: object) => ["users", "list", cid, f] as const,
    notificationPrefs: (userId: string | null) =>
      ["users", "notification-prefs", userId] as const,
    all: (cid: string | null, allCompanies: boolean) =>
      ["users", "all", cid, { allCompanies }] as const,
    resellerOrAdmin: (cid: string | null, roleId: string | null) =>
      ["users", "reseller-or-admin", cid, roleId] as const,
  },
  groups: {
    all: (cid: string | null) => ["groups", "all", cid] as const,
    list: (cid: string | null, f: object) => ["groups", "list", cid, f] as const,
  },
  drivers: {
    list: (cid: string | null, f: object) => ["drivers", "list", cid, f] as const,
    one: (cid: string | null, id: string | null) => ["drivers", "one", cid, id] as const,
  },
  geofences: {
    list: (cid: string | null, f: object) => ["geofences", "list", cid, f] as const,
  },
  centinela: {
    catalogs: () => ["centinela", "catalogs"] as const,
    units: (cid: string | null, demo: boolean) =>
      ["centinela", "units", cid, { demo }] as const,
    unit: (cid: string | null, deviceId: string | null, demo: boolean) =>
      ["centinela", "unit", cid, deviceId, { demo }] as const,
    unitCalls: (cid: string | null, deviceId: string | null, demo: boolean) =>
      ["centinela", "unit-calls", cid, deviceId, { demo }] as const,
    unitEvents: (cid: string | null, deviceId: string | null, demo: boolean) =>
      ["centinela", "unit-events", cid, deviceId, { demo }] as const,
    unitMedia: (
      cid: string | null,
      deviceId: string | null,
      demo: boolean,
      /**
       * La ventana: un número de horas, o una fecha `YYYY-MM-DD`.
       *
       * Van en la MISMA posición porque son excluyentes —se pide un día o se
       * piden las últimas N horas— y separarlas en dos claves dejaría llaves
       * con un hueco que no significa nada. Lo que no puede faltar es que
       * cambie: sin esto, elegir otro día devolvía la respuesta cacheada del
       * anterior.
       */
      ventana: number | string,
    ) => ["centinela", "unit-media", cid, deviceId, { demo, ventana }] as const,
    unitConduccion: (
      cid: string | null,
      deviceId: string | null,
      demo: boolean,
      fecha: string,
      horas: number | null,
      incluir: string,
    ) =>
      [
        "centinela",
        "unit-conduccion",
        cid,
        deviceId,
        { demo, fecha, horas, incluir },
      ] as const,
    unitParte: (
      cid: string | null,
      deviceId: string | null,
      demo: boolean,
      fecha: string,
    ) => ["centinela", "unit-parte", cid, deviceId, { demo, fecha }] as const,
    unitBitacora: (
      cid: string | null,
      deviceId: string | null,
      demo: boolean,
      horas: number,
      tipos: string,
    ) => ["centinela", "unit-bitacora", cid, deviceId, { demo, horas, tipos }] as const,
    caseMedia: (cid: string | null, caseId: string | null, demo: boolean) =>
      ["centinela", "case-media", cid, caseId, { demo }] as const,
    summary: (cid: string | null, demo: boolean) =>
      ["centinela", "summary", cid, { demo }] as const,
    config: (cid: string | null, demo: boolean) =>
      ["centinela", "config", cid, { demo }] as const,
    usage: (cid: string | null, demo: boolean) =>
      ["centinela", "usage", cid, { demo }] as const,
    subscription: (cid: string | null, demo: boolean) =>
      ["centinela", "subscription", cid, { demo }] as const,
    tripCustody: (cid: string | null, tripId: string | null) =>
      ["centinela", "trip-custody", cid, tripId] as const,
    unitCustody: (cid: string | null, deviceId: string | null) =>
      ["centinela", "unit-custody", cid, deviceId] as const,
    callRecording: (cid: string | null, callId: string | null, demo: boolean) =>
      ["centinela", "call-recording", cid, callId, { demo }] as const,
    unitConfig: (cid: string | null, deviceId: string | null, demo: boolean) =>
      ["centinela", "unit-config", cid, deviceId, { demo }] as const,
    users: (cid: string | null, demo: boolean) =>
      ["centinela", "users", cid, { demo }] as const,
    numeros: (cid: string | null, demo: boolean) =>
      ["centinela", "numeros", cid, { demo }] as const,
    voces: (cid: string | null, demo: boolean) =>
      ["centinela", "voces", cid, { demo }] as const,
    supervisores: (cid: string | null, demo: boolean) =>
      ["centinela", "supervisores", cid, { demo }] as const,
    geofenceSuggestionJob: (cid: string | null, jobId: string | null, demo: boolean) =>
      ["centinela", "geofence-suggestion-job", cid, jobId, { demo }] as const,
    cases: (cid: string | null, f: object, demo: boolean) =>
      ["centinela", "cases", cid, f, { demo }] as const,
  },
  routes: {
    all: (cid: string | null) => ["routes", "all", cid] as const,
    list: (cid: string | null, f: object) => ["routes", "list", cid, f] as const,
    detail: (cid: string | null, id: string | null) =>
      ["routes", "detail", cid, id] as const,
  },
  pointsInterest: {
    all: (cid: string | null) => ["pointsInterest", "all", cid] as const,
    list: (cid: string | null, f: object) =>
      ["pointsInterest", "list", cid, f] as const,
  },
  availableDrivers: (cid: string | null) =>
    ["availableDrivers", "all", cid] as const,
  availableUsers: (cid: string | null, currentDriverId?: string) =>
    ["availableUsers", "all", cid, currentDriverId ?? null] as const,
  sessions: {
    list: (cid: string | null, f: object) => ["sessions", "list", cid, f] as const,
  },
  trips: {
    list: (cid: string | null, f: object) => ["trips", "list", cid, f] as const,
  },
  // Cotizador de costos operativos (transportistas) + Finanzas operativas.
  quotes: {
    list: (cid: string | null, f: object) => ["quotes", "list", cid, f] as const,
    detail: (cid: string | null, id: string | null) => ["quotes", "detail", cid, id] as const,
  },
  costProfiles: {
    all: (cid: string | null) => ["costProfiles", "all", cid] as const,
    detail: (cid: string | null, id: string | null) => ["costProfiles", "detail", cid, id] as const,
    defaultFor: (cid: string | null, vehicleClass: string | null) =>
      ["costProfiles", "default", cid, vehicleClass] as const,
    catalog: () => ["costProfiles", "catalog"] as const,
  },
  finance: {
    entries: (cid: string | null, f: object) => ["finance", "entries", cid, f] as const,
    summary: (cid: string | null, f: object) => ["finance", "summary", cid, f] as const,
    tripProfitability: (cid: string | null, tripId: string | null) =>
      ["finance", "trip-profitability", cid, tripId] as const,
  },
  trackingLinks: {
    list: (cid: string | null, f: object) => ["trackingLinks", "list", cid, f] as const,
    detail: (cid: string | null, id: string | null) =>
      ["trackingLinks", "detail", cid, id] as const,
  },
  trackingReplays: {
    list: (cid: string | null, f: object) => ["trackingReplays", "list", cid, f] as const,
  },
  shipments: {
    list: (cid: string | null, f: object) => ["shipments", "list", cid, f] as const,
    detail: (cid: string | null, id: string | null) =>
      ["shipments", "detail", cid, id] as const,
  },
  smartTracking: {
    config: (cid: string | null) => ["smartTracking", "config", cid] as const,
  },
  notifications: {
    list: (cid: string | null, f: object) => ["notifications", "list", cid, f] as const,
  },
  liteNotifications: (cid: string | null) => ["liteNotifications", cid] as const,
  trailers: {
    list: (cid: string | null, f: object) => ["trailers", "list", cid, f] as const,
    available: (cid: string | null) => ["trailers", "available", cid] as const,
  },
  companies: {
    list: (f: object) => ["companies", "list", f] as const,
  },
  avisos: {
    list: (cid: string | null, f: object) => ["avisos", "list", cid, f] as const,
  },
  reseller: {
    integrators: (f: object) => ["resellerIntegrators", "list", f] as const,
    providers: (f: object) => ["resellerProviders", "list", f] as const,
    licenses: (f: object) => ["resellerLicenses", "list", f] as const,
    models: (f: object) => ["resellerModels", "list", f] as const,
  },
  companyIntegrators: (cid: string | null) => ["companyIntegrators", cid] as const,
} as const;
